import {
  AppContext,
  IDP,
  idpPath,
  Loader,
  Logout as LogOut,
  usePermission,
} from "@ctsu/loader";
import React, { Suspense, useContext, cloneElement } from "react";
import { Provider } from "react-redux";

import { GoogleAnalytics } from "@ctsu/react-ctsu-ui";
import { createBrowserHistory } from "history";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import AppContent from "./AppContent";
import Permission from "./components/common/Permission";
import LogIn from "./components/Login";
import { getGAId } from "./helpers/utils";
import appRoutes from "./routes/appRoutes";
import store from "./stores";

const history = createBrowserHistory();
const Loading = () => <div>...Loading</div>;

//testing code changes
function Login() {
  const location = useLocation();
  let redirectTo = "/browser2";

  if (location.state && location.state.redirectTo) {
    redirectTo = decodeURIComponent(location.state.redirectTo);
  }

  return <LogIn page={<Navigate to={redirectTo} />} />;
}
const Logout = () => <LogOut logout={<Navigate to="/" />} />;
const GotoLogin = () => <Navigate to="/login" />;


function Protect() {
  const context = useContext(AppContext);
  const { session } = context;
  const authenticated = session?.username;
  if (authenticated) {
    return <Permission />;
  }
  return <GotoLogin />;
}

function ProtectedRoute({ permission, element }) {
  const hasPermit = usePermission(permission);
  if (hasPermit) {
    return (
      <div id="app-context" data-permission={permission}>
        {cloneElement(element, {})}
      </div>
    );
  }

 return <Protect />
}


let flatRoutes = [];
appRoutes.forEach((route) => {
  flatRoutes.push(route);
  if (route.subRoutes) {
    flatRoutes = [...flatRoutes, ...route.subRoutes];
  }
});


export default function App() {
  return (
    <Provider store={store}>
      <Loader loadIndicator={<Loading />}>
        <BrowserRouter history={history}>
          <Suspense fallback={<div>Loading...</div>}>
            <AppContent>
              <Routes>
                <Route path={idpPath} element={<IDP />} />
                <Route exact path="/logout" element={<Logout />} />
                <Route exact path="/login" element={<Login />} />
                {flatRoutes.map(({ path,  isExact, element,  permission }) => (
                  <Route
                    key={path}
                    exact={isExact}
                    path={path}
                    element={<ProtectedRoute {...{ permission, element }} />}
                  />
                ))}
              </Routes>
              <GoogleAnalytics
                application={process.env.REACT_APP_NAME}
                gaTrackingId={getGAId()}
              />
            </AppContent>
          </Suspense>
        </BrowserRouter>
      </Loader>
    </Provider>
  );
}
